const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://iusif797.github.io/yosef-portfolio';
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const sharedProjects = {
  myProjects: { ru: 'Мои Проекты', en: 'My Projects', he: 'הפרויקטים שלי' },
  filterAll: { ru: 'Все', en: 'All', he: 'הכל' },
  filterWeb: { ru: 'Сайты', en: 'Websites', he: 'אתרים' },
  filterApp: { ru: 'Приложения', en: 'Apps', he: 'אפליקציות' },
  subtitle: {
    ru: 'Избранные работы с аккуратной подачей, живыми ссылками и деталями интерфейса',
    en: 'Selected work with live links, polished interfaces and production details',
    he: 'עבודות נבחרות עם קישורים חיים, פרטי ממשק והגשה נקייה',
  },
  visitSite: { ru: 'Посетить сайт', en: 'Visit Website', he: 'בקר באתר' },
  openPreview: { ru: 'Открыть скриншот', en: 'Open screenshot', he: 'פתח צילום מסך' },
};

const projectLabels = (lang) => ({
  myProjects: sharedProjects.myProjects[lang] ?? sharedProjects.myProjects.en,
  filterAll: sharedProjects.filterAll[lang] ?? sharedProjects.filterAll.en,
  filterWeb: sharedProjects.filterWeb[lang] ?? sharedProjects.filterWeb.en,
  filterApp: sharedProjects.filterApp[lang] ?? sharedProjects.filterApp.en,
  subtitle: sharedProjects.subtitle[lang] ?? sharedProjects.subtitle.en,
  visitSite: sharedProjects.visitSite[lang] ?? sharedProjects.visitSite.en,
  openPreview: sharedProjects.openPreview[lang] ?? sharedProjects.openPreview.en,
});

export const translations = {
  ru: {
    siteUrl: SITE_URL,
    ogImage: OG_IMAGE,
    title: 'Портфолио Юсифа Мамедова - Веб-разработчик',
    description: 'Профессиональная веб-разработка в Чехии и Европе. Сайты, мобильные приложения, Telegram-боты и CRM-системы для бизнеса.',
    keywords: 'веб-разработка, портфолио, Юсиф Мамедов, Прага',
    author: 'Юсиф Мамедов',
    jobTitle: 'Веб-разработчик',
    skipLink: 'Перейти к содержимому',
    nav: {
      home: 'Главная',
      about: 'Обо мне',
      process: 'Процесс',
      projects: 'Проекты',
      tech: 'Стек',
      pricing: 'Цены',
      reviews: 'Отзывы',
      faq: 'FAQ',
      contact: 'Контакты',
      cta: 'Связаться',
    },
    header: {
      studioTitle: 'Моё Портфолио',
      aboutMe: 'Full-Stack разработчик с 5+ годами опыта. Создаю сайты, мобильные приложения, Telegram-ботов для разных сфер и CRM-системы под задачи бизнеса. React, Node.js и современный стек.',
    },
    about: {
      title: 'Опыт, который работает на вас',
      subtitle: '5+ лет в разработке высоконагруженных веб-приложений',
      description: 'Я не просто пишу код — я создаю решения, которые помогают бизнесу расти: от лендингов до Telegram-ботов и CRM с автоматизацией процессов.',
      stats: [
        { value: 40, suffix: '%', label: 'Рост конверсии' },
        { value: 50, suffix: '+', label: 'Успешных проектов' },
        { value: 1, suffix: 'M+', label: 'Пользователей' },
      ],
    },
    process: {
      title: 'Как мы работаем',
      subtitle: 'Прозрачный процесс от идеи до запуска',
      steps: [
        { title: 'Бриф и созвон', desc: 'Обсуждаем цели, аудиторию, сроки и бюджет. Фиксируем задачи в коротком ТЗ.' },
        { title: 'Прототип и дизайн', desc: 'Согласуем структуру, визуальный стиль и ключевые экраны до начала разработки.' },
        { title: 'Разработка', desc: 'Пишу чистый код, показываю промежуточные версии и вношу правки по ходу.' },
        { title: 'Тестирование', desc: 'Проверяю на всех устройствах, скорость загрузки, SEO и формы обратной связи.' },
        { title: 'Запуск и поддержка', desc: 'Деплой на ваш домен, передача доступов и сопровождение после релиза.' },
      ],
    },
    tech: {
      title: 'Технологии',
      subtitle: 'Инструменты, с которыми я создаю быстрые и надёжные продукты',
    },
    projects: projectLabels('ru'),
    testimonials: {
      title: 'Отзывы клиентов',
      subtitle: 'Что говорят о работе со мной',
      items: [
        { quote: 'Сайт запустили за 3 недели, конверсия выросла уже в первый месяц. Всё прозрачно и профессионально.', name: 'Anna K.', role: 'Владелица кафе, Прага', country: '🇨🇿' },
        { quote: 'Отличная коммуникация, чистый код и поддержка после релиза. Рекомендую как надёжного разработчика.', name: 'David M.', role: 'Основатель стартапа', country: '🇩🇪' },
        { quote: 'Сделали платформу бронирования с нуля. Быстро, аккуратно, без лишней бюрократии.', name: 'Sarah L.', role: 'Product Manager', country: '🇬🇧' },
      ],
    },
    pricing: {
      pricing: 'Цены',
      subtitle: 'Сайты, приложения, Telegram-боты и CRM — выберите формат под вашу задачу',
      mobileApp: 'Мобильное Приложение',
      website: 'Сайт',
      businessCard: 'Бизнес Визитка',
      telegramBot: 'Telegram-бот',
      crm: 'CRM-система',
      priceMobileApp: 'От 6 000 €',
      priceWebsite: 'От 1 500 €',
      priceBusinessCard: 'От 280 €',
      priceTelegramBot: 'От 800 €',
      priceCrm: 'От 4 000 €',
      popular: 'Популярно',
      order: 'Заказать',
      features: {
        website: ['Адаптивный дизайн', 'SEO оптимизация', 'Быстрая загрузка', 'Современный дизайн'],
        mobile: ['iOS & Android', 'Нативная производительность', 'Push уведомления', 'Интеграция с API'],
        card: ['Уникальный дизайн', 'Контактная информация', 'QR код', 'Социальные сети'],
        bot: ['Заявки и автоответы', 'Интеграция с CRM и API', 'Платежи и уведомления', 'Админ-панель'],
        crm: ['Клиенты и сделки', 'Роли и права доступа', 'Аналитика и отчёты', 'Telegram и email'],
      },
    },
    faq: {
      title: 'Частые вопросы',
      subtitle: 'Ответы на то, что обычно спрашивают клиенты',
      items: [
        { q: 'Сколько времени занимает разработка сайта?', a: 'Лендинг — от 1–2 недель, корпоративный сайт — 3–6 недель, сложное приложение — от 2 месяцев.' },
        { q: 'Как происходит оплата?', a: 'Обычно 50% предоплата перед стартом и 50% после сдачи. Для крупных проектов — поэтапная оплата.' },
        { q: 'Сколько правок включено?', a: 'В стоимость входят согласованные итерации на этапах дизайна и разработки.' },
        { q: 'Что входит в цену «от 1 500 €»?', a: 'Адаптивная вёрстка, базовое SEO, форма связи, оптимизация скорости и деплой.' },
        { q: 'Предоставляете поддержку после запуска?', a: 'Да. Первые 30 дней — бесплатные мелкие правки. Далее — почасовая поддержка или абонент.' },
        { q: 'Работаете удалённо с клиентами из других стран?', a: 'Да, работаю с клиентами по всей Европе. Созвоны по Zoom, Telegram или WhatsApp.' },
        { q: 'Какие Telegram-боты вы делаете?', a: 'Боты для заявок, записи, каталогов, уведомлений и оплат — с админкой и интеграцией в CRM или сайт.' },
        { q: 'CRM пишете с нуля или на готовой платформе?', a: 'Под задачу: кастомная CRM под ваш процесс или доработка существующей системы с нужными модулями.' },
      ],
    },
    contact: {
      contact: 'Связаться со мной',
      subtitle: 'Готов воплотить ваши идеи в жизнь. Свяжитесь со мной любым удобным способом.',
      scrollToContact: 'Связаться со мной',
      yourName: 'Ваше Имя',
      yourEmail: 'Ваш Email',
      message: 'Ваше Сообщение',
      send: 'Отправить',
      sending: 'Отправка...',
      projectType: 'Тип проекта',
      formTitle: 'Отправить сообщение',
      formSubtitle: 'Расскажите о своем проекте',
      location: 'Прага, Чехия',
      types: { website: 'Сайт', mobile: 'Мобильное приложение', card: 'Бизнес-визитка', bot: 'Telegram-бот', crm: 'CRM-система' },
      nameRequired: 'Пожалуйста, введите ваше имя.',
      emailRequired: 'Пожалуйста, введите ваш Email.',
      emailInvalid: 'Пожалуйста, введите корректный Email.',
      messageRequired: 'Пожалуйста, введите сообщение.',
      statusSuccess: 'Сообщение успешно отправлено!',
      statusError: 'Ошибка отправки. Попробуйте ещё раз или напишите на email.',
    },
    footer: {
      aboutTitle: 'О разработчике',
      aboutText: 'Full-Stack разработчик с 5+ годами опыта. Сайты, Telegram-боты, CRM и мобильные решения для бизнеса.',
      servicesTitle: 'Услуги',
      services: ['Веб-разработка', 'Telegram-боты', 'CRM-системы', 'Мобильные приложения'],
      contactTitle: 'Контакты',
      rights: 'Все права защищены',
      github: 'GitHub профиль',
      linkedin: 'LinkedIn профиль',
      telegram: 'Telegram',
    },
    legal: {
      bannerAria: 'Уведомление о файлах cookie',
      bannerText: 'Мы используем необходимые cookie для работы сайта и при согласии — Google Tag Manager для аналитики.',
      acceptAll: 'Принять все',
      rejectOptional: 'Только необходимые',
      privacyPolicy: 'Политика конфиденциальности',
      privacyTitle: 'Политика конфиденциальности',
      closeModal: 'Закрыть',
      footerPrivacy: 'Конфиденциальность',
      footerCookies: 'Настройки cookie',
      formPrivacyBefore: 'Отправляя форму, вы соглашаетесь на обработку персональных данных в соответствии с',
      formPrivacyAfter: '.',
    },
    modal: { close: 'Закрыть превью', title: 'Превью проекта' },
  },
  en: {
    siteUrl: SITE_URL,
    ogImage: OG_IMAGE,
    title: "Yosef Mamedov's Portfolio - Web Developer",
    description: 'Professional web development in Czech Republic and Europe. Websites, mobile apps, Telegram bots and CRM systems for business.',
    keywords: 'web development, portfolio, Yosef Mamedov, Prague',
    author: 'Yosef Mamedov',
    jobTitle: 'Web Developer',
    skipLink: 'Skip to content',
    nav: {
      home: 'Home', about: 'About', process: 'Process', projects: 'Projects', tech: 'Stack',
      pricing: 'Pricing', reviews: 'Reviews', faq: 'FAQ', contact: 'Contact', cta: 'Get in touch',
    },
    header: {
      studioTitle: 'My Portfolio',
      aboutMe: 'Full-Stack Developer with 5+ years of experience. I build websites, mobile apps, Telegram bots for various industries and custom CRM systems. React, Node.js and modern stack.',
    },
    about: {
      title: 'Experience That Works For You',
      subtitle: '5+ years in high-load web application development',
      description: 'I do not just write code — I build solutions that help businesses grow: from landing pages to Telegram bots and CRM with process automation.',
      stats: [
        { value: 40, suffix: '%', label: 'Conversion Growth' },
        { value: 50, suffix: '+', label: 'Successful Projects' },
        { value: 1, suffix: 'M+', label: 'Users Served' },
      ],
    },
    process: {
      title: 'How We Work',
      subtitle: 'A transparent path from idea to launch',
      steps: [
        { title: 'Brief & Call', desc: 'We align on goals, audience, timeline and budget. Tasks are captured in a short spec.' },
        { title: 'Prototype & Design', desc: 'Structure, visual direction and key screens are approved before development starts.' },
        { title: 'Development', desc: 'Clean, maintainable code with regular previews and iterative feedback.' },
        { title: 'Testing', desc: 'Cross-device QA, performance, SEO and contact flows verified before go-live.' },
        { title: 'Launch & Support', desc: 'Deployment to your domain, handover of access and post-release support.' },
      ],
    },
    tech: {
      title: 'Tech Stack',
      subtitle: 'Tools I use to build fast, reliable products',
    },
    projects: projectLabels('en'),
    testimonials: {
      title: 'Client Reviews',
      subtitle: 'What clients say about working with me',
      items: [
        { quote: 'We launched in 3 weeks and conversion grew in the first month. Transparent and professional.', name: 'Anna K.', role: 'Cafe Owner, Prague', country: '🇨🇿' },
        { quote: 'Great communication, clean code and post-launch support. Highly recommended.', name: 'David M.', role: 'Startup Founder', country: '🇩🇪' },
        { quote: 'Built our booking platform from scratch. Fast, polished, no unnecessary bureaucracy.', name: 'Sarah L.', role: 'Product Manager', country: '🇬🇧' },
      ],
    },
    pricing: {
      pricing: 'Pricing',
      subtitle: 'Websites, apps, Telegram bots and CRM — pick the format for your goal',
      mobileApp: 'Mobile Application',
      website: 'Website',
      businessCard: 'Business Card',
      telegramBot: 'Telegram Bot',
      crm: 'CRM System',
      priceMobileApp: 'From 6 000 €',
      priceWebsite: 'From 1 500 €',
      priceBusinessCard: 'From 280 €',
      priceTelegramBot: 'From 800 €',
      priceCrm: 'From 4 000 €',
      popular: 'Popular',
      order: 'Order Now',
      features: {
        website: ['Responsive Design', 'SEO Optimization', 'Fast Loading', 'Modern Design'],
        mobile: ['iOS & Android', 'Native Performance', 'Push Notifications', 'API Integration'],
        card: ['Unique Design', 'Contact Information', 'QR Code', 'Social Media'],
        bot: ['Leads & auto-replies', 'CRM & API integration', 'Payments & alerts', 'Admin panel'],
        crm: ['Clients & deals pipeline', 'Roles & permissions', 'Analytics & reports', 'Telegram & email'],
      },
    },
    faq: {
      title: 'FAQ',
      subtitle: 'Answers to what clients usually ask',
      items: [
        { q: 'How long does a website take?', a: 'A landing page takes 1–2 weeks, a corporate site 3–6 weeks, complex apps from 2 months.' },
        { q: 'How does payment work?', a: 'Typically 50% upfront and 50% on delivery. Larger projects can be split into milestones.' },
        { q: 'How many revisions are included?', a: 'Agreed iterations during design and development are included.' },
        { q: 'What is included from €1,500?', a: 'Responsive build, basic SEO, contact form, performance optimization and deployment.' },
        { q: 'Do you offer post-launch support?', a: 'Yes. Minor fixes are free for 30 days after launch.' },
        { q: 'Do you work remotely with international clients?', a: 'Yes, across Europe and beyond via Zoom, Telegram or WhatsApp.' },
        { q: 'What Telegram bots do you build?', a: 'Lead bots, booking, catalogs, notifications and payments — with admin panel and CRM or website integration.' },
        { q: 'Do you build CRM from scratch?', a: 'Depends on the task: custom CRM for your workflow or extending an existing system with the modules you need.' },
      ],
    },
    contact: {
      contact: 'Contact Me',
      subtitle: 'Ready to bring your ideas to life. Contact me in any convenient way.',
      scrollToContact: 'Contact Me',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      message: 'Your Message',
      send: 'Send',
      sending: 'Sending...',
      projectType: 'Project Type',
      formTitle: 'Send Message',
      formSubtitle: 'Tell me about your project',
      location: 'Prague, Czech Republic',
      types: { website: 'Website', mobile: 'Mobile Application', card: 'Business Card', bot: 'Telegram Bot', crm: 'CRM System' },
      nameRequired: 'Please enter your name.',
      emailRequired: 'Please enter your Email.',
      emailInvalid: 'Please enter a valid Email.',
      messageRequired: 'Please enter a message.',
      statusSuccess: 'Message sent successfully!',
      statusError: 'Failed to send. Please try again or email directly.',
    },
    footer: {
      aboutTitle: 'About Developer',
      aboutText: 'Full-Stack developer with 5+ years of experience. Websites, Telegram bots, CRM and mobile solutions for business.',
      servicesTitle: 'Services',
      services: ['Web Development', 'Telegram Bots', 'CRM Systems', 'Mobile Apps'],
      contactTitle: 'Contact',
      rights: 'All rights reserved',
      github: 'GitHub profile',
      linkedin: 'LinkedIn profile',
      telegram: 'Telegram',
    },
    legal: {
      bannerAria: 'Cookie notice',
      bannerText: 'We use essential cookies for the site to work and, if you agree, Google Tag Manager for analytics.',
      acceptAll: 'Accept all',
      rejectOptional: 'Essential only',
      privacyPolicy: 'Privacy Policy',
      privacyTitle: 'Privacy Policy',
      closeModal: 'Close',
      footerPrivacy: 'Privacy',
      footerCookies: 'Cookie settings',
      formPrivacyBefore: 'By submitting this form, you agree to the processing of your personal data as described in the',
      formPrivacyAfter: '.',
    },
    modal: { close: 'Close preview', title: 'Project preview' },
  },
  he: {
    siteUrl: SITE_URL,
    ogImage: OG_IMAGE,
    title: 'פורטפוליו של יוסף ממדוב - מפתח אתרים',
    description: 'פיתוח אתרים מקצועי בצ\'כיה ואירופה. אתרים, אפליקציות, בוטים בטלגרם ומערכות CRM לעסקים.',
    keywords: 'פיתוח אתרים, פורטפוליו, יוסף ממדוב, פראג',
    author: 'יוסף ממדוב',
    jobTitle: 'מפתח אתרים',
    skipLink: 'דלג לתוכן',
    nav: {
      home: 'בית', about: 'אודות', process: 'תהליך', projects: 'פרויקטים', tech: 'טכנולוגיות',
      pricing: 'מחירים', reviews: 'ביקורות', faq: 'שאלות', contact: 'צור קשר', cta: 'צור קשר',
    },
    header: {
      studioTitle: 'הפורטפוליו שלי',
      aboutMe: 'מפתח Full-Stack עם 5+ שנות ניסיון. בונה אתרים, אפליקציות, בוטים בטלגרם לתחומים שונים ומערכות CRM מותאמות אישית.',
    },
    about: {
      title: 'ניסיון שעובד בשבילך',
      subtitle: '5+ שנים בפיתוח יישומי רשת בעומס גבוה',
      description: 'אני לא רק כותב קוד — אני בונה פתרונות שעוזרים לעסקים לצמוח: מדפי נחיתה ועד בוטים בטלגרם ו-CRM עם אוטומציה.',
      stats: [
        { value: 40, suffix: '%', label: 'גידול בהמרה' },
        { value: 50, suffix: '+', label: 'פרויקטים מוצלחים' },
        { value: 1, suffix: 'M+', label: 'משתמשים' },
      ],
    },
    process: {
      title: 'איך אנחנו עובדים',
      subtitle: 'תהליך שקוף מרעיון ועד השקה',
      steps: [
        { title: 'בריף ושיחה', desc: 'מגדירים מטרות, קהל יעד, לוחות זמנים ותקציב.' },
        { title: 'אב טיפוס ועיצוב', desc: 'מסכימים על מבנה וכיוון ויזואלי לפני הפיתוח.' },
        { title: 'פיתוח', desc: 'קוד נקי עם הדגמות שוטפות ומשוב לאורך הדרך.' },
        { title: 'בדיקות', desc: 'בדיקה על כל המכשירים, ביצועים, SEO וטפסים.' },
        { title: 'השקה ותמיכה', desc: 'פריסה לדומיין, מסירת גישות וליווי לאחר ההשקה.' },
      ],
    },
    tech: {
      title: 'טכנולוגיות',
      subtitle: 'כלים שבהם אני בונה מוצרים מהירים ואמינים',
    },
    projects: projectLabels('he'),
    testimonials: {
      title: 'ביקורות לקוחות',
      subtitle: 'מה לקוחות אומרים על העבודה איתי',
      items: [
        { quote: 'השקנו תוך 3 שבועות וההמרה עלתה בחודש הראשון. שקוף ומקצועי.', name: 'Anna K.', role: 'בעלת בית קפה, פראג', country: '🇨🇿' },
        { quote: 'תקשורת מצוינת, קוד נקי ותמיכה אחרי ההשקה. מומלץ בחום.', name: 'David M.', role: 'מייסד סטארטאפ', country: '🇩🇪' },
        { quote: 'בנו את פלטפורמת ההזמנות מאפס. מהיר, מדויק, בלי בירוקרטיה.', name: 'Sarah L.', role: 'Product Manager', country: '🇬🇧' },
      ],
    },
    pricing: {
      pricing: 'מחירים',
      subtitle: 'אתרים, אפליקציות, בוטים בטלגרם ו-CRM — בחרו את הפורמט המתאים',
      mobileApp: 'אפליקציה ניידת',
      website: 'אתר',
      businessCard: 'כרטיס ביקור',
      telegramBot: 'בוט טלגרם',
      crm: 'מערכת CRM',
      priceMobileApp: 'מ-6 000 €',
      priceWebsite: 'מ-1 500 €',
      priceBusinessCard: 'מ-280 €',
      priceTelegramBot: 'מ-800 €',
      priceCrm: 'מ-4 000 €',
      popular: 'פופולרי',
      order: 'הזמן עכשיו',
      features: {
        website: ['עיצוב רספונסיבי', 'אופטימיזציה לקידום', 'טעינה מהירה', 'עיצוב מודרני'],
        mobile: ['iOS ו-Android', 'ביצועים נטיביים', 'התראות דחיפה', 'אינטגרציה עם API'],
        card: ['עיצוב ייחודי', 'פרטי יצירת קשר', 'קוד QR', 'רשתות חברתיות'],
        bot: ['לידים ותשובות אוטומטיות', 'אינטגרציה עם CRM ו-API', 'תשלומים והתראות', 'פאנל ניהול'],
        crm: ['לקוחות ועסקאות', 'תפקידים והרשאות', 'אנליטיקה ודוחות', 'טלגרם ואימייל'],
      },
    },
    faq: {
      title: 'שאלות נפוצות',
      subtitle: 'תשובות לשאלות שמעסיקות לקוחות',
      items: [
        { q: 'כמה זמן לוקח לפתח אתר?', a: 'דף נחיתה — 1–2 שבועות, אתר תדמית — 3–6 שבועות, אפליקציה מורכבת — מ-2 חודשים.' },
        { q: 'איך מתבצע התשלום?', a: 'בדרך כלל 50% מקדמה ו-50% במסירה.' },
        { q: 'כמה תיקונים כלולים?', a: 'איטרציות מוסכמות בשלב העיצוב והפיתוח כלולות.' },
        { q: 'מה כלול במחיר «מ-1,500 €»?', a: 'בנייה רספונסיבית, SEO בסיסי, טופס יצירת קשר, אופטימיזציה ופריסה.' },
        { q: 'יש תמיכה אחרי ההשקה?', a: 'כן. 30 יום ראשונים — תיקונים קטנים בחינם.' },
        { q: 'עובדים מרחוק עם לקוחות מחו״ל?', a: 'כן, עם לקוחות באירופה ומחוצה לה.' },
        { q: 'אילו בוטים בטלגרם אתם בונים?', a: 'בוטים ללידים, הזמנות, קטלוגים, התראות ותשלומים — עם פאנל ניהול ואינטגרציה ל-CRM או לאתר.' },
        { q: 'בונים CRM מאפס?', a: 'לפי הצורך: CRM מותאם אישית לתהליך שלכם או הרחבת מערכת קיימת עם המודולים הנדרשים.' },
      ],
    },
    contact: {
      contact: 'צור קשר',
      subtitle: 'מוכן להביא את הרעיונות שלכם לחיים. צרו קשר בכל דרך נוחה.',
      scrollToContact: 'צור קשר',
      yourName: 'שמך',
      yourEmail: 'האימייל שלך',
      message: 'ההודעה שלך',
      send: 'שלח',
      sending: 'שולח...',
      projectType: 'סוג פרויקט',
      formTitle: 'שלח הודעה',
      formSubtitle: 'ספר לי על הפרויקט שלך',
      location: 'פראג, צ\'כיה',
      types: { website: 'אתר', mobile: 'אפליקציה ניידת', card: 'כרטיס ביקור', bot: 'בוט טלגרם', crm: 'מערכת CRM' },
      nameRequired: 'אנא הכנס את שמך.',
      emailRequired: 'אנא הכנס את האימייל שלך.',
      emailInvalid: 'אנא הכנס אימייל תקין.',
      messageRequired: 'אנא הכנס הודעה.',
      statusSuccess: 'ההודעה נשלחה בהצלחה!',
      statusError: 'שליחה נכשלה. נסה שוב או שלח אימייל ישירות.',
    },
    footer: {
      aboutTitle: 'על המפתח',
      aboutText: 'מפתח Full-Stack עם ניסיון של 5+ שנים. אתרים, בוטים בטלגרם, CRM ופתרונות מובייל לעסקים.',
      servicesTitle: 'שירותים',
      services: ['פיתוח אתרים', 'בוטים בטלגרם', 'מערכות CRM', 'אפליקציות מובייל'],
      contactTitle: 'צור קשר',
      rights: 'כל הזכויות שמורות',
      github: 'פרופיל GitHub',
      linkedin: 'פרופיל LinkedIn',
      telegram: 'Telegram',
    },
    legal: {
      bannerAria: 'הודעת עוגיות',
      bannerText: 'אנו משתמשים בעוגיות הכרחיות לפעילות האתר וב-Google Tag Manager לאנליטיקה.',
      acceptAll: 'קבל הכל',
      rejectOptional: 'הכרחי בלבד',
      privacyPolicy: 'מדיניות פרטיות',
      privacyTitle: 'מדיניות פרטיות',
      closeModal: 'סגור',
      footerPrivacy: 'פרטיות',
      footerCookies: 'הגדרות עוגיות',
      formPrivacyBefore: 'בשליחת הטופס אתם מסכימים לעיבוד הנתונים האישיים בהתאם ל',
      formPrivacyAfter: '.',
    },
    modal: { close: 'סגור תצוגה מקדימה', title: 'תצוגה מקדימה של פרויקט' },
  },
};

export const getTranslation = (language) => translations[language] || translations.en;

export const detectLanguage = () => {
  const stored = localStorage.getItem('portfolio-lang');
  if (stored && translations[stored]) return stored;
  const browser = (navigator.language || 'en').slice(0, 2);
  if (browser === 'ru' || browser === 'he') return browser;
  return 'ru';
};
